
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {NewSearchWidgetSportTypeClickEvent} from "../../models/analytics/new-search-widget.sport-type.click-event";

export class NewSearchWidgetSportTypeClickEventHandler extends AnalyticsEventHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSportTypeClickEvent;

  static injectables = [AnalyticsService];

  async action(params) {
    const clickEvent: NewSearchWidgetSportTypeClickEvent = new NewSearchWidgetSportTypeClickEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
